import constant from "../constant";
import axios from "axios";

// Create an Axios instance
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || constant.api.replace("/api/", ""),
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

// Add request interceptor to inject Authorization header
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(constant.authToken);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token.replaceAll('"', "")}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

// Export API utility functions for use in Vuex modules
export const api = {
  async get(url, params = {}) {
    const response = await instance.get(url, { params });
    console.log("API GET response:", response);
    console.log("API GET response.data:", response.data);
    return response.data || response;
  },

  async post(url, data) {
    const response = await instance.post(url, data);
    console.log("API POST response:", response);
    console.log("API POST response.data:", response.data);
    return response.data || response;
  },

  async put(url, data) {
    const response = await instance.put(url, data);
    return response.data || response;
  },

  async delete(url) {
    const response = await instance.delete(url);
    return response.data || response;
  },
};

export default instance;
